(function () {
  'use strict';

  var STORAGE_KEY = 'bh_scroll_restore';
  var STALE_MS = 5000;
  var SUPPRESS_WINDOW_MS = 1000;

  var suppressUntil = 0;

  var origScrollIntoView = Element.prototype.scrollIntoView;
  Element.prototype.scrollIntoView = function () {
    if (Date.now() < suppressUntil) return;
    return origScrollIntoView.apply(this, arguments);
  };

  var origScrollTo = window.scrollTo.bind(window);
  window.scrollTo = function () {
    if (Date.now() < suppressUntil) {
      var args = arguments;
      if (args.length === 1 && typeof args[0] === 'object' && args[0] && args[0].behavior === 'smooth') return;
    }
    return origScrollTo.apply(window, arguments);
  };

  function isVariantTrigger(el) {
    if (!el) return false;
    return !!(
      el.closest('[data-sibling-products]') ||
      el.closest('.product__color-swatches') ||
      el.closest('.product__color-chips') ||
      el.closest('[data-option-buttons]')
    );
  }

  function saveScrollForNav() {
    try {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify({
        y: window.scrollY || window.pageYOffset || 0,
        ts: Date.now()
      }));
    } catch (e) {}
  }

  function restoreScrollAfterNav() {
    var raw;
    try { raw = sessionStorage.getItem(STORAGE_KEY); } catch (e) { return; }
    if (!raw) return;
    try { sessionStorage.removeItem(STORAGE_KEY); } catch (e) {}

    var saved;
    try { saved = JSON.parse(raw); } catch (e) { return; }
    if (!saved || typeof saved.y !== 'number') return;
    if (Date.now() - saved.ts > STALE_MS) return;

    suppressUntil = Date.now() + SUPPRESS_WINDOW_MS;
    origScrollTo(0, saved.y);
    requestAnimationFrame(function () { origScrollTo(0, saved.y); });
  }

  if ('scrollRestoration' in history) {
    try { history.scrollRestoration = 'manual'; } catch (e) {}
  }

  document.addEventListener('click', function (evt) {
    if (isVariantTrigger(evt.target)) {
      suppressUntil = Date.now() + SUPPRESS_WINDOW_MS;
      saveScrollForNav();
    }
  }, true);

  document.addEventListener('product:variant-change', function () {
    suppressUntil = Date.now() + SUPPRESS_WINDOW_MS;
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', restoreScrollAfterNav);
  } else {
    restoreScrollAfterNav();
  }
})();
